import React, { useEffect, useState } from 'react';
import { CheckboxGroupInput, useDataProvider, useNotify } from 'react-admin';
import { Box, Button, Typography } from '@material-ui/core';
import { useTranslate } from '../common/language';

export const SessionDiscounts = ({ formData }) => {
  const translate = useTranslate();
  const provider = useDataProvider();
  const notify = useNotify();
  const sessionId = formData.id;
  const [choices, setChoices] = useState([]);
  const [loadedSession, setLoadedSession] = useState(null);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let current = true;
    setLoadedSession(null);
    setFailed(false);
    if (!sessionId) return undefined;
    provider.getList('events_sessions_discounts', {
      pagination: { page: 1, perPage: 1000 },
      sort: { field: 'priority', order: 'ASC' },
      filter: { events_sessions_id: sessionId }
    }).then(({ data }) => {
      if (current) {
        setChoices(data.filter(discount => discount.active === true));
        setLoadedSession(sessionId);
      }
    }).catch(error => {
      if (current) {
        setFailed(true);
        notify(error.message, 'error');
      }
    });
    return () => { current = false; };
  }, [provider, sessionId, notify]);

  return (
    <Box mt={2}>
      <Typography variant="h6">{translate('tickets_discounts.title')}</Typography>
      <Typography variant="body2">{translate('tickets_discounts.session_help')}</Typography>
      {failed ? <Typography color="error">{translate('tickets_discounts.session_load_error')}</Typography>
        : loadedSession !== sessionId ? <Typography>{translate('ra.page.loading')}</Typography>
        : choices.length ? (
          <CheckboxGroupInput
            source="tickets_discounts_ids"
            label=""
            choices={choices}
            optionText={discount => discount.name + ' (' + (discount.type === 'BUY_X_PAY_Y'
              ? discount.quantity_x + 'x' + discount.quantity_y : discount.percentage + '%') + ')'}
          />
        ) : <Typography>{translate('tickets_discounts.session_empty')}</Typography>}
      <Button
        component="a"
        href="#/settings-tickets-discounts"
        target="_blank"
        rel="noopener noreferrer"
        color="primary"
      >
        {translate('tickets_discounts.session_config_button')}
      </Button>
    </Box>
  );
};
